import { Injectable } from "@angular/core";
import { A, AA, B, C, ENGLISH, FACTORYOFFSET, MONTH_NAMES, SAVED_CLUSTER_LIST, SELECTED_CLUSTER, SELECTED_FACTORY } from "src/app/app.contant";
import { DataService } from "./data.service";

@Injectable({
  providedIn: "root",
})
export class UtilsService {
  // defaultLanguage: any;
  // isLocalName: boolean;
  // currentLanguage: any;
  // lineListFilter: any;
  // dfosLineName: any;
  constructor(private dataSer: DataService) { }

  findObjInArray(arr: any[], keyToCheck: string, valueToCheck: any) {
    if (!arr) {
      return null;
    }
    return arr.find((iteratedObj) => iteratedObj[keyToCheck] === valueToCheck);
  }

  timeStampConverter(timestamp: any, convertToFactoryTime = true) {
    let factOffsetTime: any;
    if (sessionStorage.getItem(FACTORYOFFSET)) {
      factOffsetTime = JSON.parse(this.dataSer.getStorageData(FACTORYOFFSET));
    }
    if (!factOffsetTime) {
      factOffsetTime = 0;
    }
    // machine offset gives the value in minutes to add inorder to get ts in utc
    const machineOffsetTimeInMs = new Date().getTimezoneOffset() * 60 * 1000;

    let result = timestamp;
    if (convertToFactoryTime) {
      result = timestamp - machineOffsetTimeInMs - factOffsetTime;
    } else {
      result = timestamp + machineOffsetTimeInMs + factOffsetTime;
    }
    return result;
  }

  csvConverter(time: any) {
    const date = new Date(time);
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = monthNames[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    const hour = date.getHours();
    const minutes = date.getMinutes();
    const convertedDate =
      month + "-" + day + "-" + year + "-" + hour + ":" + minutes;
    return convertedDate;
  }

  mapSKUName(sku: any) {
    return sku ? sku.skuName : undefined;
  }

  mapSKUNameega(sku: any) {
    return sku ? sku.skuname : undefined;
  }

  autoCompleteFilter(value: string, arr: any[] = [], key: any): string[] {
    let filterValue = "";
    if (value && value.length) {
      filterValue = value.toLowerCase();
    } else if (value && value[key]) {
      filterValue = value[key].toLowerCase();
    }
    return arr.filter((option) =>
      option[key].toLowerCase().includes(filterValue)
    );
  }

  selectedClusterFactoryURLCreator(clutername = null, factoryName = null) {
    const c: any = this.dataSer.getStorageData(SELECTED_CLUSTER);
    const f: any = this.dataSer.getStorageData(SELECTED_FACTORY);
    const cl = this.dataSer.getStorageData(SAVED_CLUSTER_LIST);
    const storedCluster = c ? JSON.parse(c) : null;
    const storedFactory = f ? JSON.parse(f) : null;
    const cml = cl ? JSON.parse(cl) : null;
    let url = '';

    if (!clutername || !factoryName) {
      url = 'clusters/' + storedCluster?.name + '/factories/' + storedFactory?.name;
      return url;
    }
    const cChek = this.findObjInArray(cml, 'name', clutername);
    const fCheck = cChek ? this.findObjInArray(cChek.factories, "name", factoryName) : null;
    if (!cChek || !fCheck) {
      return null;
    }
    url = 'clusters/' + cChek?.name + '/factories/' + fCheck?.name;
    this.dataSer.setStorageData(SELECTED_CLUSTER, JSON.stringify(cChek));
    this.dataSer.setStorageData(SELECTED_FACTORY, JSON.stringify(fCheck));
    return url;
  }

  public convertUTCDateToLocalDate(date: Date): Date {
    if (!date) {
      return null;
    }
    const newDate = new Date(
      date.getTime() + date.getTimezoneOffset() * 60 * 1000
    );
    const offset = date.getTimezoneOffset() / 60;
    const hours = date.getHours();
    newDate.setHours(hours - offset);
    return newDate;
  }

  public formatDateMonYYYY(d: string): string {
    if (!d || d === "") {
      return "";
    }
    const date = new Date(d);
    const monthIndex = date.getMonth();
    const monthName = MONTH_NAMES[monthIndex];
    const year = date.getFullYear();
    return `${monthName} ${year}`;
  }

  public formatDateMonDDYYYY(d: string): string {
    if (!d || d === '') {
      return '';
    }
    const date = new Date(d);
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const monthName = MONTH_NAMES[monthIndex];
    const year = date.getFullYear();
    return `${monthName} ${day}, ${year}`;
  }

  public formatDateMonDDYYYYHHMM(d: string): string {
    if (!d || d === '') {
      return '';
    }
    const date = new Date(d);
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const monthName = MONTH_NAMES[monthIndex];
    const year = date.getFullYear();
    const hh = date.getHours();
    const mi = 10 > date.getMinutes() ? '0' + date.getMinutes() : date.getMinutes();
    return `${monthName} ${day}, ${year}  ${hh}:${mi}`;
  }

  // 30 Aug 22 15:25
  public formatDateDDMonYYHHMM(d: string): string {
    if (!d || d === '') {
      return '';
    }
    const date = new Date(d);
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const monthName = MONTH_NAMES[monthIndex];
    const year = date.getFullYear() % 100;
    const hh = date.getHours();
    const mi =
      10 > date.getMinutes() ? '0' + date.getMinutes() : date.getMinutes();
    return `${day} ${monthName} ${year} ${hh}:${mi}`;
  }

  public formatDateDDMonYYYY(d: string): string {
    if (!d || d === '') {
      return '';
    }
    const date = new Date(d);
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const monthName = MONTH_NAMES[monthIndex];
    const year = date.getFullYear();
    return `${day} ${monthName} ${year}`;
  }

  public greaterThanCurrentDate(d: string): boolean {
    if (!d || d === '') {
      return false;
    }
    const d1 = new Date(d);
    const d2 = new Date();
    return d1.getTime() > d2.getTime();
  }

  //sort with respect to chracter and number
  // list : array on on which sort need to apply
  // sortParam: The key on which sort have to apply

  sortWrtCharAndNum(list: any, sortParam: string) {
    return Array.from(list)
      .map((data: any) => {
        return {
          ...data,
          sortField: data[sortParam]
            ?.replace(/[^a-z\d\s]+/gi, "")
            .split(" ")
            .join("")
            .toLowerCase(),
        };
      })
      .sort((listObjA: any, listObjB: any) => {
        return ("" + listObjA.sortField).localeCompare(
          listObjB.sortField,
          "en",
          {
            numeric: true,
          }
        );
      });
  }

  sortByClassificationPriority<T>(list: T[] = [], key: keyof T | string = 'classification'): T[] {
    const classificationOrder = [AA, A, B, C];

    return Array.from(list).sort((left: any, right: any) => {
      const leftValue = ((left?.[key] ?? '') as string).toString().trim().toUpperCase();
      const rightValue = ((right?.[key] ?? '') as string).toString().trim().toUpperCase();
      const leftPriority = classificationOrder.indexOf(leftValue);
      const rightPriority = classificationOrder.indexOf(rightValue);

      if (leftPriority === -1 && rightPriority === -1) {
        return 0;
      }
      if (leftPriority === -1) {
        return 1;
      }
      if (rightPriority === -1) {
        return -1;
      }
      return leftPriority - rightPriority;
    });
  }

  changeDisplayOfLineName(lineListFilter: any, currentLanguage: any, dfosLineName: any) {
    const factory = sessionStorage.getItem(SELECTED_FACTORY);
    const selFactory = factory ? JSON.parse(factory) : null;
    const defaultLanguage = selFactory ? selFactory.language : '';
    const isLocalName = currentLanguage == defaultLanguage && currentLanguage != ENGLISH &&
      defaultLanguage != ENGLISH;
    lineListFilter.forEach((element: any) => {
      if (element.dfosactive === true && isLocalName) {
        dfosLineName.forEach((e: any) => {
          if (e.name === element.linename) {
            element.linename = e.localName;
          }
        });
      }
    });
  }

  public convertCsvText(s: string): string {
    if (!s) {
      return '';
    }
    if (s.trim().indexOf('=') === 0) {
      return `"${s}"`;
    }
    return s;
  }

  // public convertCsvText(s: any): string {
  //   if (s === null || s === undefined) {
  //     return '';
  //   }
  //   const value = String(s);
  //   if (value.trim().indexOf('=') === 0) {
  //     return `"${value}"`;
  //   }
  //   return value;

  // }
  downloadFile(data, filename) {
    if (data.size > 0) {
      const downloadURL = window.URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);
      link.remove();
    }
  }
  replaceRegionClusterFactory(response) {
    const transformed = response.data.map(item => ({
      region: item.region,
      clusterId: item.region,
      clusterName: item.region,
      factories: item.factories
    }));

    return transformed;
  }

  // public generateCsv(data: any[], fileName: any): void {

  //   if (!data || !data.length) {
  //     console.log('No CSV data found');
  //     return;
  //   }

  //   const headers = Object.keys(data[0]);
  //   const csvRows = [];
  //   // Header row
  //   csvRows.push(headers.join(','));
  //   // Data rows
  //   data.forEach((row: any) => {
  //     const values = headers.map((header: string) => {
  //       let cell = row[header];
  //       if (cell === null || cell === undefined) {
  //         cell = '';
  //       }
  //       cell = String(cell).replace(/"/g, '""');
  //       return `"${cell}"`;
  //     });
  //     csvRows.push(values.join(','));
  //   });
  //   const csvString = csvRows.join('\n');
  //   const blob = new Blob(
  //     [csvString],
  //     { type: 'text/csv;charset=utf-8;' }
  //   );
  //   const link = document.createElement('a');
  //   const url = window.URL.createObjectURL(blob);
  //   link.setAttribute('href', url);
  //   link.setAttribute('download', fileName);
  //   link.style.visibility = 'hidden';
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // }
}
